module.exports = __webpack_public_path__ + "static/media/logotipico_primary.7c6b8fed.webp";